// Module
var code = "<template>\r\n  <router-view></router-view>\r\n</template>";
// Exports
export default code;